/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const ShowPasswordIcon = ({ fill = "#686868 " }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.12476 14.664L3.99581 15L4.12476 15.336C5.82696 19.7706 10.0402 22.9375 15 22.9375C19.9598 22.9375 24.173 19.7706 25.8752 15.336L26.0042 15L25.8752 14.664C24.173 10.2294 19.9598 7.0625 15 7.0625C10.0402 7.0625 5.82696 10.2294 4.12476 14.664Z"
      stroke={fill}
      strokeWidth="1.875"
    />
    <circle cx="15.0002" cy="15.0002" r="3.16324" fill={fill} />
  </svg>
);

export default ShowPasswordIcon;
